'use client';

import Link from 'next/link';
import MarketingHeader from '@/components/MarketingHeader';
import MarketingFooter from '@/components/MarketingFooter';
import { getBrandContactUrl, getBrandHomeUrl } from '@/lib/creatorPlatformUrls';

export default function MoreServicesPage() {
  return (
    <div className="home-page">
      <MarketingHeader />
      <main className="about-main">
        <h1 className="home-about-title">更多产品服务</h1>
        <p className="home-about-text">
          除创作者平台外，基音也在持续拓展更多产品与服务。
        </p>
        <p className="home-about-text">
          如您对版权作品、合作机会或定制服务感兴趣，欢迎通过下方方式与我们联系。
        </p>
        <p style={{ marginTop: '1.5rem' }}>
          <Link href={getBrandContactUrl()} className="link-hover">
            联系我们
          </Link>
        </p>
        <p style={{ marginTop: '2rem', fontSize: '0.875rem' }}>
          <Link href={getBrandHomeUrl()} className="link-hover">&lt; 返回首页</Link>
        </p>
      </main>
      <MarketingFooter />
    </div>
  );
}
